import React from 'react';
import MobileView from './mobile/MobileView';

function App() {
  return <MobileView />;
}

export default App;
